import { useSelector } from "react-redux";
import { DisplayPrice } from "../api/generated";
import { getApproximatePrices, getCurrency, getCurrencyIsPrefixed, getLanguage } from "../store/sagas/selectors";
import { useText } from "./textUtil";

export class PriceFormatter {
    currency: string | null;

    currencyIsPrefixed: boolean;

    missingText: string | null;

    approximatePrefix: string | null;

    locale: string;

    constructor(
        currency: string | null,
        currencyIsPrefixed: boolean,
        missingText: string | null,
        approximatePrefix: string | null,
        locale: string
    ) {
        this.currency = currency;
        this.currencyIsPrefixed = currencyIsPrefixed;
        this.missingText = missingText;
        this.approximatePrefix = approximatePrefix;
        this.locale = locale;
    }

    formatDisplayPrice(price: DisplayPrice | undefined | null): string | null {
        return this.formatPrice(price?.priceValue);
    }

    formatPrice(priceValue: number | undefined | null): string | null {
        if (!priceValue) return this.missingText;
        let text = priceValue.toLocaleString(this.locale);
        if (this.currency) {
            text = this.currencyIsPrefixed ? `${this.currency} ${text}` : `${text} ${this.currency}`;
        }
        if (this.approximatePrefix) {
            text = `${this.approximatePrefix} ${text}`;
        }
        return text;
    }
}

export function usePriceFormatter(showMissingText: boolean) {
    const currency = useSelector(getCurrency) || null;
    const currencyIsPrefixed = useSelector(getCurrencyIsPrefixed) || false;
    const approximatePrices = useSelector(getApproximatePrices);
    const language = useSelector(getLanguage);
    const t = useText();
    const missingText: string | null = showMissingText ? t("priceMissing", null) : null;
    const approximatePrefix: string | null = approximatePrices ? t("approximatePrice", null) : null;

    return new PriceFormatter(
        currency,
        currencyIsPrefixed,
        missingText,
        approximatePrefix,
        language?.toLowerCase() || "sv"
    );
}
